$(document).ready(function() {
  $('.button-enquire').click(function() {
    $('.popup-enquiry').addClass('active');
  });
  $('.popup-enquiry .popup-close').click(function() {
    $('.popup-enquiry').removeClass('active');
  });
  
  $(".popup-enquiry").click(function(e){
    if(e.target == this){ // only if the target itself has been clicked
       $(this).removeClass('active');
    }
  });

  $('.timber_swatch__select [name="Timber Swatch"]').on('change', function() {
    var timber = $(this).val()
    $('[name="options[Timber]"]select').val(timber)
  })
});

